import { z } from "zod";
import {
  notificationTypeSchema,
  subscriptionParametersUnknownRecordSchema,
} from "../_shared";

export const platformSubscriptionsPerCompanyItemSchema = z.object({
  uuid: z.uuid(),
  company: z.uuid(),
  type: notificationTypeSchema,
  parameters: subscriptionParametersUnknownRecordSchema,
});

export const platformSubscriptionsPerCompanyResponseSchema = z.array(
  platformSubscriptionsPerCompanyItemSchema,
);

export type PlatformSubscriptionsPerCompanyItem = z.infer<
  typeof platformSubscriptionsPerCompanyItemSchema
>;
export type PlatformSubscriptionsPerCompanyResponse = z.infer<
  typeof platformSubscriptionsPerCompanyResponseSchema
>;
